import { render, staticRenderFns } from "./CategoryImage.vue?vue&type=template&id=51212d38&scoped=true&"
import script from "./CategoryImage.vue?vue&type=script&lang=js&"
export * from "./CategoryImage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryImage.vue?vue&type=style&index=0&id=51212d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51212d38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
